export {
  Domain as SplineDomain,
  Spline,
  SplineProps,
  Ticks as SplineTicks,
} from './Spline';
